import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const STORIES = [
  {
    client: "Muthoot Finance",
    sector: "Financial services · Branch expansion",
    ask: "High-visibility, ground-floor branch spaces in dense residential catchments across Indore — compliant, accessible and customer-friendly.",
    find: "Corner units on established arterial roads with strong footfall, clear signage rights and interiors suited to secure financial operations.",
    outcome: "A smooth multi-branch rollout that turned into a long-standing advisory relationship across the city.",
  },
  {
    client: "D-Mart",
    sector: "Large-format retail",
    ask: "Anchor-scale retail space with the unglamorous essentials done right — parking depth, loading access, power and compliant floor plates.",
    find: "A high-catchment location with the specifications big-box retail actually needs, evaluated down to turning radius and delivery bays.",
    outcome: "A store that opened on plan and continues to anchor its catchment — exactly what patient evaluation buys.",
  },
  {
    client: "Titan Eye+",
    sector: "Premium retail · Showroom",
    ask: "A high-street showroom in a proven retail corridor, where brand visibility and walk-in quality matter more than raw size.",
    find: "A prominent frontage in an established shopping destination, negotiated with terms that protect the tenant's long-term position.",
    outcome: "A flagship-quality presence that keeps drawing the right footfall, season after season.",
  },
];

export default function CaseStudies() {
  return (
    <section className="cases-section section-wrap" data-testid="case-studies">
      <div className="section-heading-row">
        <div><p className="eyebrow">LEASE STORIES</p><h2>The space they needed.<br /><em>The outcome they got.</em></h2></div>
        <span className="section-index">03 / STORIES</span>
      </div>
      <div className="cases-list">
        {STORIES.map((story, index) => (
          <article className="case-card" key={story.client} data-testid={`case-study-${index}`}>
            <div className="case-side">
              <span className="case-number">0{index + 1}</span>
              <h3>{story.client}</h3>
              <span className="case-sector">{story.sector}</span>
            </div>
            <div className="case-body">
              <div><span>THE ASK</span><p>{story.ask}</p></div>
              <div><span>THE FIND</span><p>{story.find}</p></div>
              <div><span>THE OUTCOME</span><p>{story.outcome}</p></div>
            </div>
          </article>
        ))}
      </div>
      <div className="cases-cta">
        <p>Your expansion could be the next story.</p>
        <Link className="button button-gold" to="/contact" data-testid="cases-cta-button">Discuss your requirement <ArrowUpRight size={16} /></Link>
      </div>
    </section>
  );
}
